import { createFileRoute } from "@tanstack/react-router";
import AgenteIA from "../../pages/soluciones/AgenteIA";

export const Route = createFileRoute("/que-hacemos/agente-ia")({
  component: AgenteIA,
});
